import React, { useEffect } from "react";
import useState from "react-usestateref";
import PageTitle from "../components/PageTitle/PageTitle";
import { Box, CircularProgress, Grid, Modal } from "@material-ui/core";
import { toast } from "react-toastify";
import apiService from "../core/service/detail";
import { postMethod, getMethod } from "../core/service/common.api";
import Pagination from "@material-ui/lab/Pagination";
import { Typography } from "@material-ui/core";
import useStyles from "../components/Header/styles";
import moment from "moment";
import CKEditor from "react-ckeditor-component";
import SearchBar from "./searchbar";
import Skeleton from "react-skeleton-loader";
import * as Icons from "@material-ui/icons";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "none",
  outline: "none",
  boxShadow: 24,
  borderRadius: "10px",
  p: 4,
};

function Job() {
  //Job status
  const [jobpoststatus, setjobpoststatus] = useState("Active");
  const [loader, setLoader] = useState(false);
  const [pageLoader, setpageLoader] = useState(false);
  const [imageLoader, setimageLoader] = useState(false);

  const poststatus = (e) => {
    setjobpoststatus(e.target.value);
  };
  const [experienceErr, setExperienceErr] = useState(false);
  var classes = useStyles();

  const [state, setState] = useState({
    content: "",
  });

  const updateContent = (newContent) => {
    setState({
      content: newContent,
    });
  };

  const onChange = (evt) => {
    console.log("onChange fired with event info: ", evt);
    var newContent = evt.editor.getData();
    setState({
      content: newContent,
    });
  };

  const onBlur = (evt) => {
    console.log("onBlur event called with event info: ", evt);
  };

  const afterPaste = (evt) => {
    console.log("afterPaste event called with event info: ", evt);
  };

  //BANNER UPLOAD

  const [jobbanner, setJobBanner] = useState();
  var jobBannerUpload = (val) => {
    try {
      console.log("fileExtension===", val.name);

      const fileExtension = val.name.split(".").at(-1);
      const fileSize = val.size;
      const fileName = val.name;
      console.log("fileExtension===", fileExtension);
      console.log("fileSize===", fileSize);
      console.log("fileName===", fileName);
      if (
        fileExtension != "png" &&
        fileExtension != "jpg" &&
        fileExtension != "jpeg" &&
        fileExtension != "webp"
      ) {
        toast.error(
          "File does not support. You must use .png or .jpg or .jpeg ",
        );
        return false;
      } else if (fileSize > 1000000) {
        toast.error("Please upload a file smaller than 1 MB");
        return false;
      } else {
        setimageLoader(true);
        const data = new FormData();
        data.append("file", val);
        data.append("upload_preset", "ebjirh4i");
        data.append("cloud_name", "blf");
        console.log("formdata===", data);
        fetch("  https://api.cloudinary.com/v1_1/blf/auto/upload", {
          method: "post",
          body: data,
        })
          .then((resp) => resp.json())
          .then((data) => {
            setimageLoader(false);
            console.log("cloudinary upload===", data);
            setJobBanner(data.secure_url);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    } catch (err) {
      console.log(err, "erro--=--=-=-=-=-=");
    }
  };

  var initialvalues = {
    jobDepartment: "",
    jobtiming: "",
    jobPosition: "",
    jobDescription: "",
    location: "",
    skills: "",
    experience: "",
  };

  var [inputvalues, setInputvalues] = useState(initialvalues);

  const {
    jobDepartment,
    jobtiming,
    jobPosition,
    jobDescription,
    location,
    skills,
  } = inputvalues;

  useEffect(() => {
    get_job_Details();
  }, []);
  var [Slug, setSlug, Slugref] = useState("");

  var handleChange = (e) => {
    try {
      e.preventDefault();
      const { name, value } = e.target;
      let datas = { ...inputvalues, ...{ [name]: value } };
      setInputvalues(datas);

      var slug = datas.jobPosition
        .toLowerCase()
        .replace(/ /g, "-")
        .replace(/[^\w-]+/g, "");
      setSlug(slug);
    } catch (err) {
      console.log(err, "erro--=--=-=-=-=-=");
    }
  };

  var [departmentErr, setdepartmentErr, departmentErrref] = useState(false);
  var [jobtimingErr, setjobimingErr, jobtimingErrref] = useState(false);
  var [jobPositionErr, setjobPositionErr, jobPositionErrref] = useState(false);
  var [locationErr, setlocationErr, locationErrref] = useState(false);
  var [DescriptionErr, setDescriptionErr, DescriptionErrref] = useState(false);
  var [skillsErr, setSkillsErr, skillsErrref] = useState(false);
  var [bannerErr, setBannerErr, bannerErrref] = useState(false);
  var [validate, setvalidate] = useState(false);

  const vallidation = (inputvalues) => {
    try {
      var error = {};
      if (inputvalues.jobDepartment == "") {
        setdepartmentErr(true);
        error.jobDepartment = "Job Department can't be empty";
      } else {
        setdepartmentErr(false);
      }
      if (inputvalues.jobtiming == "") {
        setjobimingErr(true);
        error.jobtiming = "Job Timing can't be empty";
      } else {
        setjobimingErr(false);
      }
      if (inputvalues.jobPosition == "") {
        setjobPositionErr(true);
        error.jobPosition = " Position can't be empty";
      } else {
        setjobPositionErr(false);
      }
      if (inputvalues.jobDescription == "") {
        setDescriptionErr(true);
        error.jobDescription = " Description can't be empty";
      } else {
        setDescriptionErr(false);
      }
      if (inputvalues.location == "") {
        setlocationErr(true);
        error.location = "Location can't be empty";
      } else {
        setlocationErr(false);
      }
      if (inputvalues.skills == "") {
        setSkillsErr(true);
        error.skills = "Skill Details can't be empty";
      } else {
        setSkillsErr(false);
      }
      if (inputvalues.experience == "") {
        setExperienceErr(true);
        error.skills = "Experience is required";
      } else {
        setExperienceErr(false);
      }
      if (jobbanner == "" || jobbanner == null || jobbanner == undefined) {
        error.jobbanner = " Intern Banner can't be empty";
        setBannerErr(true);
      } else {
        setBannerErr(false);
      }

      setvalidate(error);
    } catch (err) {
      console.log(err, "err=-=-=-=-=-=-=-=-=-=-=-=-=-=-=");
    }
  };
  const [viewstatus, setviewstatus] = useState(false);

  const submit_job_Details = async (e) => {
    try {
      e.preventDefault();
      if (
        departmentErrref.current == false &&
        jobtimingErrref.current == false &&
        jobPositionErrref.current == false &&
        locationErrref.current == false &&
        DescriptionErrref.current == false &&
        skillsErrref.current == false &&
        experienceErr == false &&
        bannerErrref.current == false
      ) {
        var obj = {
          jobDepartment: inputvalues.jobDepartment,
          jobtiming: inputvalues.jobtiming,
          jobPosition: inputvalues.jobPosition,
          jobDescription: inputvalues.jobDescription,
          location: inputvalues.location,
          skills: inputvalues.skills,
          experience: inputvalues.experience,
          jobbanner: jobbanner,
          jobpoststatus: jobpoststatus,
          content: state.content,
          jobslug: Slug,
        };
        setLoader(true);
        var data = {
          apiUrl: apiService.submit_job_Details,
          payload: obj,
        };
        var resp = await postMethod(data);
        setLoader(false);
        if (resp.Status == true) {
          get_job_Details();
          toast.success(resp.Message);
          setformstatus(false);
          setState({
            content: "",
          });
        } else {
          toast.error(resp.Message);
        }
      } else {
        console.log("oooo");
      }
    } catch (error) {
      console.log(error, "-0-0-0-0-0-0-0-0-0-0-0-0-0-0-0-errerererer");
    }
  };
  const [jobDetails, setjobdetails] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalpages] = useState(0);
  console.log(totalPage, "totalPage");
  const recordPerPage = 5;
  const pageRange = 5;

  const handlePageChange = (pageNumber) => {
    get_job_Details(pageNumber);
    setCurrentPage(pageNumber);
  };

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [deleteId, setdeleteId] = useState("");

  const get_job_Details = async (page, search) => {
    try {
      var payload = {
        perpage: 10,
        page: page,
        search,
      };
      var data = {
        apiUrl: apiService.get_job_Details,
        payload: payload,
      };
      setpageLoader(true);
      var resp = await postMethod(data);
      setpageLoader(false);
      if (resp.Status == true) {
        setjobdetails(resp.data.data);
        setTotalpages(resp.data.pages);
      } else {
      }
    } catch (error) {
      console.log(error, "-0-0-0-0-0-0-0-0-0-0-0-0-0-0-0-errerererer");
    }
  };

  const back = () => {
    setformstatus(false);
  };

  const [itemid, setitemid] = useState();

  const view_job_Details = async (item) => {
    try {
      setviewstatus(true);
      setformstatus(true);
      console.log(item);
      inputvalues.jobDepartment = item.jobDepartment;
      inputvalues.jobtiming = item.jobtiming;
      inputvalues.jobPosition = item.jobPosition;
      inputvalues.jobDescription = item.jobDescription;
      inputvalues.location = item.location;
      inputvalues.skills = item.skills;
      setJobBanner(item.jobbanner);
      setjobpoststatus(item.internpoststatus);
      setitemid(item._id);
      setSlug(item.jobslug);
      setState({
        content: item.content,
      });
    } catch (error) {
      console.log(error, "-0-0-0-0-0-0-0-0-0-0-0-0-0-0-0-errerererer");
    }
  };
  const edit_job_Details = async (e) => {
    try {
      e.preventDefault();
      var payload = {
        id: itemid,
        jobDepartment: inputvalues.jobDepartment,
        jobtiming: inputvalues.jobtiming,
        jobPosition: inputvalues.jobPosition,
        jobDescription: inputvalues.jobDescription,
        location: inputvalues.location,
        skills: inputvalues.skills,
        experience: inputvalues.experience,
        jobbanner: jobbanner,
        jobpoststatus: jobpoststatus,
        content: state.content,
        jobslug: Slug,
      };
      setLoader(true);
      var data = {
        apiUrl: apiService.edit_job_Details,
        payload: payload,
      };
      var resp = await postMethod(data);
      setLoader(false);
      if (resp.Status == true) {
        toast.success(resp.Message);
        setformstatus(false);
        get_job_Details();
      } else {
        toast.error(resp.Message);
      }
    } catch (error) {
      console.log(error, "-0-0-0-0-0-0-0-0-0-0-0-0-0-0-0-errerererer");
    }
  };
  const delete_job_Details = async (item) => {
    try {
      var payload = {
        id: item,
      };
      var data = {
        apiUrl: apiService.delete_job_Details,
        payload: payload,
      };
      var resp = await postMethod(data);
      if (resp.Status == true) {
        toast.success(resp.Message);
        get_job_Details();
        handleClose();
      } else {
        toast.error(resp.Message);
      }
    } catch (error) {
      console.log(error, "-0-0-0-0-0-0-0-0-0-0-0-0-0-0-0-errerererer");
    }
  };
  const [formstatus, setformstatus] = useState(false);
  const formstatusChange = () => {
    try {
      setformstatus(true);
      setInputvalues((prev) => ({
        ...prev,
        jobDepartment: "",
        jobtiming: "",
        jobPosition: "",
        jobDescription: "",
        location: "",
        skills: "",
        experience: "",
      }));
      setJobBanner("");
      setState((prev) => ({
        ...prev,
        content: "",
      }));
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      {formstatus == true ? (
        <>
          {/* <div className="d-flex justify-space-between">
            <h3>Job Form</h3>
            <button className="btn btn-primary custom_btn" >
              Back
            </button>
          </div> */}
          <div className="d-flex flex-wrap align-items-center justify-content-between py-2">
            <div>
              <PageTitle title="Job Form" className="mob_mb_10" />
            </div>

            <div className="right_top">
              <div className="btn_add" onClick={back}>
                <span>Back</span>
              </div>
            </div>
          </div>
          <div className="card blog_upload_card">
            <div className="row">
              <div className="col-md-6">
                <div className="form-group mb-4">
                  <label className="blg_upld_label">Opening Department</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Opening Department"
                    name="jobDepartment"
                    value={inputvalues.jobDepartment}
                    onChange={handleChange}
                  />
                  {departmentErr == true ? (
                    <p style={{ color: "red", fontSize: "14px" }}>
                      {validate.jobDepartment}
                    </p>
                  ) : null}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group mb-4">
                  <label className="blg_upld_label">Opening Position</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Opening Position"
                    name="jobPosition"
                    value={inputvalues.jobPosition}
                    onChange={handleChange}
                  />
                  {jobPositionErr == true ? (
                    <p style={{ color: "red", fontSize: "14px" }}>
                      {validate.jobPosition}
                    </p>
                  ) : null}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group mb-4">
                  <label className="blg_upld_label"> Description</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder=" Description"
                    name="jobDescription"
                    value={inputvalues.jobDescription}
                    onChange={handleChange}
                  />
                  {DescriptionErr == true ? (
                    <p style={{ color: "red", fontSize: "14px" }}>
                      {validate.jobDescription}
                    </p>
                  ) : null}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group mb-4">
                  <label className="blg_upld_label">Location</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Location"
                    name="location"
                    value={inputvalues.location}
                    onChange={handleChange}
                  />
                  {locationErr == true ? (
                    <p style={{ color: "red", fontSize: "14px" }}>
                      {validate.location}
                    </p>
                  ) : null}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group mb-4">
                  <label className="blg_upld_label">Timing</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Timing"
                    name="jobtiming"
                    value={inputvalues.jobtiming}
                    onChange={handleChange}
                  />
                  {jobtimingErr == true ? (
                    <p style={{ color: "red", fontSize: "14px" }}>
                      {validate.jobtiming}
                    </p>
                  ) : null}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group mb-4">
                  <label className="blg_upld_label">Skills</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Skills"
                    name="skills"
                    value={inputvalues.skills}
                    onChange={handleChange}
                  />
                  {skillsErr == true ? (
                    <p style={{ color: "red", fontSize: "14px" }}>
                      {validate.skills}
                    </p>
                  ) : null}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group mb-4">
                  <label className="blg_upld_label">Experience</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Experience"
                    name="experience"
                    value={inputvalues.experience}
                    onChange={handleChange}
                  />
                  {experienceErr == true ? (
                    <p style={{ color: "red", fontSize: "14px" }}>
                      {validate.experience}
                    </p>
                  ) : null}
                </div>
              </div>
              <div className="col-md-6">
                <div class="form-group mb-4">
                  <label for="email"> Job Status</label>
                  <div className="copy_icon">
                    <select
                      id="input-gender"
                      className="form-control "
                      name="jobpoststatus"
                      value={jobpoststatus}
                      onChange={poststatus}
                    >
                      <option value="">Choose</option>
                      <option value="Active">Active</option>
                      <option value="DeActive">DeActive</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group ">
                  <label
                    htmlFor="exampleInputPassword1"
                    className="blg_upld_label"
                  >
                    Job Banner
                  </label>
                  <div className="selected_img_container">
                    {imageLoader == true ? (
                      <div className="blg_file_input_wrap">
                        <i class="fa-solid fa-spinner fa-spin"></i>
                      </div>
                    ) : jobbanner ? (
                      <>
                        <input
                          type="file"
                          className="selected_img_file_input"
                          id="customFile"
                          onChange={(e) => jobBannerUpload(e.target.files[0])}
                        />
                        <img src={jobbanner} alt="Blog" className="w-100" />
                        {/* <label className="blg_upld_label"
                                >
                                  {blogLabel}
                                </label> */}
                      </>
                    ) : (
                      <>
                        <div className="blg_file_input_wrap">
                          <i class="fa-solid fa-cloud-arrow-up"></i>
                          <label className="blg_upld_label">Upload</label>
                          <input
                            type="file"
                            className="blg_file_input"
                            id="customFile"
                            onChange={(e) => jobBannerUpload(e.target.files[0])}
                          />
                        </div>

                        {bannerErr == true ? (
                          <p style={{ color: "red", fontSize: "14px" }}>
                            {validate.jobbanner}
                          </p>
                        ) : null}
                      </>
                    )}
                  </div>

                  {/* <div>
                    <input
                      type="file"
                      className="custom-file"
                      id="customFile"
                      onChange={(e) => (e.target.files[0])}
                    />
                   
                  </div> */}
                </div>
              </div>
              {/* {jobbanner == "" ||
              jobbanner == null ||
              jobbanner == undefined ? (
                ""
              ) : (
                <img width="50" height="50" src={jobbanner} />
              )} */}
              <div className="col-md-6">
                <div className="form-group mb-4 ">
                  <label
                    htmlFor="exampleInputPassword1"
                    className="blg_upld_label"
                  >
                    {" "}
                    Link
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder=" URL"
                    value={Slugref.current}
                    disabled
                  />
                </div>
              </div>
              <div className="col-12">
                <div className="form-group mb-4 ">
                  <label
                    htmlFor="exampleInputPassword1"
                    className="blg_upld_label"
                  >
                    Job Content
                  </label>

                  <CKEditor
                    activeClass="p10"
                    content={state.content}
                    events={{
                      blur: onBlur,
                      afterPaste: afterPaste,
                      change: onChange,
                    }}
                  />
                </div>
              </div>

              {viewstatus == false ? (
                loader == false ? (
                  <button
                    className="btn btn-primary custom_btn"
                    onClick={submit_job_Details}
                  >
                    Sumbit
                  </button>
                ) : (
                  <button className="btn btn-primary custom_btn">
                    Loading...
                  </button>
                )
              ) : loader == false ? (
                <button
                  className="btn btn-primary custom_btn"
                  onClick={edit_job_Details}
                >
                  Sumbit
                </button>
              ) : (
                <button className="btn btn-primary custom_btn">
                  Loading...
                </button>
              )}
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="d-flex flex-wrap align-items-center justify-content-between py-2">
            <div>
              <PageTitle title="Job Posts" className="mob_mb_10" />
            </div>

            <div className="right_top">
              <SearchBar
                placeholder="Search by Department"
                className="mb-3"
                onSearch={(term) => get_job_Details(1, term)}
              />
              <div className="btn_add" onClick={formstatusChange}>
                <span>Add</span>
                <Icons.AddCircle />
              </div>
            </div>
          </div>

          <div className="col-12 grid-margin mt-3 mt-md-0">
            <div className="table_outer">
              <div className="table-responsive">
                <table className="table m-0 table-striped">
                  <thead className="admin_thead">
                    <tr>
                      <th> S.No</th>
                      <th> Department</th>
                      <th> Time </th>
                      <th> Position</th>
                      <th> Description</th>
                      <th> location</th>
                      <th> Banner</th>
                      <th> Status</th>
                      {/* <th> Action</th> */}
                      <th> Edit</th>
                      <th> Delete</th>
                    </tr>
                  </thead>

                  <tbody className="admin_tbody">
                    {pageLoader === true ? (
                      Array.from({ length: 5 }).map((_, i) => (
                        <tr key={i}>
                          <td>
                            <Skeleton />
                          </td>{" "}
                          <td>
                            <Skeleton />
                          </td>{" "}
                          <td>
                            <Skeleton />
                          </td>{" "}
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                        </tr>
                      ))
                    ) : jobDetails && jobDetails.length > 0 ? (
                      jobDetails.map((item, i) => {
                        return (
                          <tr key={item._id}>
                            <td>{i + 1}</td>
                            <td>{item.jobDepartment}</td>
                            <td>{item.jobtiming}</td>
                            <td>{item.jobPosition}</td>
                            <td>
                              <p>{item.jobDescription}</p>
                            </td>
                            <td>{item.location}</td>
                            <td>
                              <img width="50" src={item.jobbanner} />
                            </td>

                            <td>{item.jobpoststatus}</td>
                            <td
                              className="cursor-pointer"
                              onClick={() => view_job_Details(item)}
                            >
                              {" "}
                              <i className="fa fa-edit"></i>
                            </td>
                            <td
                              className="cursor-pointer"
                              onClick={() => (
                                handleOpen(), setdeleteId(item._id)
                              )}
                              // onClick={() => delete_job_Details(item)}
                            >
                              {""}
                              <i className="fa fa-trash"></i>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr className="no-record">
                        <td colSpan={10}>
                          <div className="emptyrecordimg">
                            <img
                              src={require("../images/No-data.webp")}
                              width="100px"
                            />
                            <span className="emptyrecord">
                              No records found
                            </span>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className="row justify-content-center">
                  {/* <Pagination
                    itemClass="page-item"
                    linkClass="page-link"
                    activePage={currentPage}
                    itemsCountPerPage={recordPerPage}
                    totalItemsCount={totalPage}
                    pageRangeDisplayed={pageRange}
                    onChange={handlePageChange}
                  /> */}
                  {totalPage > 1 && (
                    <Pagination
                      count={totalPage}
                      page={currentPage}
                      onChange={(event, value) => handlePageChange(value)}
                      className={classes.blog_pagination}
                      color="primary"
                      shape="rounded"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <h5 className="logout_title">Delete Notification</h5>
              <p className="logout_content">Are your sure delete this item</p>
              <div className="logout_btn_wrapper">
                <button
                  className="logout_cancel custom_btn2 text-center"
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button
                  className="logout_confirm custom_btn2 text-center"
                  onClick={() => delete_job_Details(deleteId)}
                >
                  Delete
                </button>
              </div>
            </Box>
          </Modal>
        </>
      )}
    </>
  );
}

export default Job;
